<script>
import CadastroSicarf from '@/components(new)/UI/Forms/CadastroSicarf/CadastroSicarf.vue'
import HeaderVoltar from '@/components(new)/UI/HeaderVoltar/HeaderVoltar.vue'
import empty from '@/libs/models/cadastro/emptyPraticas'
import Alert from '@/components(new)/UI/Alert/Alert.vue'
import CardBase from '@/components(new)/UI/Cards/CardBase/CardBase.vue'
import { validaTipoCadastro } from '@/utils/utils'

export default {
  components: {
    CadastroSicarf,
    HeaderVoltar,
    Alert,
    CardBase
  },
  props: {
    tipoCadastro: {
      required: true,
      validator: value => validaTipoCadastro(value)
    }
  },
  data () {
    return {
      // O atributo @name deve ser o mesmo da rota definida no router
      tabs: [
        {
          label: 'Proprietário',
          name: 'formulario-proprietario',
          codigo: 'PROPRIETARIO'
        },
        {
          label: 'Imóvel',
          name: 'formulario-imovel',
          codigo: 'IMOVEL'
        },
        {
          label: 'Uso do solo',
          name: 'formulario-uso-solo',
          codigo: 'USO_SOLO'
        },
        {
          label: 'Práticas',
          name: 'formulario-praticas',
          codigo: 'PRATICAS'
        },
        {
          label: 'Georreferenciamento',
          name: 'formulario-georreferenciamento',
          codigo: 'GEOREREFERENCIAMENTO'
        },
        {
          label: 'Anexo',
          name: 'formulario-anexos',
          codigo: 'ANEXOS'
        }
      ],
      empty: empty,
      hasProcesso: false
    }
  },
  async created () {
    this.aplicarModalidadeCadastro()
  },
  computed: {
    tabsFiltradas () {
      return this.tipoCadastro === 'EMPRESA'
        ? this.tabs.filter(obj => obj.codigo !== 'PROPRIETARIO')
        : this.tabs
    }
  },
  methods: {
    aplicarModalidadeCadastro () {
      this.empty.modalidadeCadastro = this.tipoCadastro
    },
    atualizarHasProcesso (hasProcesso) {
      this.hasProcesso = hasProcesso
    }
  }
}
</script>

<template>
  <div class="container cardResgate">
    <div class="flex-between gap-2">
      <HeaderVoltar
        label="Novo cadastro"
        pageBack="listagem/praticas"
        :hasProcesso="hasProcesso"
      />
      <Alert
        type="info"
        title="Atenção!"
        description="Ao cadastrar as práticas sustentáveis,
        considere o conjunto da área que compõe o imóvel como um todo,
        mesmo que ela esteja vinculada a mais de um CAR."
        :colapsedMode="true"
      />
    </div>
    <CardBase>
      <template #info-card>
        <cadastro-sicarf
          titleCadastro="Cadastro de práticas"
          routeName="praticas"
          :cadastroEmpty="empty"
          :tabs="tabsFiltradas"
          :tipoCadastro="tipoCadastro"
          ref="cadastroSicarf"
          @has-processo-changed="atualizarHasProcesso"
        />
      </template>
    </CardBase>
  </div>
</template>

<style lang="scss" scoped>
@import '@/scss/_mixins.scss';
@import '@/scss/_typography.scss';
@import '@/scss/_utilities.scss';

.container {
  padding: 20px;
  .card {
    width: 100%;
  }

  @media (max-width: 780px) {
    .cardResgate {
      position: relative;
      top: 50px;
      right: 60%;
      width: 350px !important;
    }
  }
}

#setFonts {
  @include margin-top-2;
  @include margin-bottom-2;
  [class^="el-"],
  [class*=" el-"] {
    @include set-rawline-regular;
  }
}
</style>



// WEBPACK FOOTER //
// src/App/(authenticated)/modulos/cadastro/formulario-cadastro/cadastro.vue